import { Text } from '@weareconceptstudio/core';

//* Styles
import RatingStyle from './style';

const Star = ({ className }) => (
	<svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path d="M10 0L12.3607 7.63932H20L13.8197 12.3607L16.1803 20L10 15.2786L3.81966 20L6.18034 12.3607L0 7.63932H7.63932L10 0Z" fill="var(--green1000)"/>
	</svg>
);

const Rating = ({ className, showText = true, rate_count = 3 }) => {
	const stars = Array.from({ length: 5 }, (_, index) => {
		if (rate_count >= index + 1) {
			return '100%';
		} else if (rate_count >= index + 0.5) {
			return '50%';
		} else {
			return '0%';
		}
	});

	return (
		<RatingStyle className={className || ''}>
			<div className='wrapper-starts-text'>
				{rate_count ? (
					<>
						{showText ? <Text className={'p p3 font-montserrat-arm-bold'}>{rate_count}</Text> : null}

						<div className={'flex'}>
							{stars.map((fillLevel, index) => (
								<div
									key={index}
									className={'relative-star'}>
									<Star className={fillLevel === '100%' ? 'color-main' : 'back-color'} />

									{fillLevel === '50%' && (
										<div className={'absolute-star'}>
											<Star className={'color-main'} />
										</div>
									)}
								</div>
							))}
						</div>
					</>
				) : null}
			</div>
		</RatingStyle>
	);
};

export default Rating;
